'use strict';

// key by ./options.js => 'ed.base.areaCode'
module.exports = Object.freeze({
	'10': {
		name: ['基隆市', 'Keelung City', '基隆市'],
		children: {
			200: { name: ['200 基隆市仁愛區', 'Ren Ai District, Keelung City 200', '200 基隆市仁爱区'] },
			201: { name: ['201 基隆市信義區', 'Xin Yi District, Keelung City 201', '201 基隆市信义区'] },
			202: { name: ['202 基隆市中正區', 'Zhong Zheng District, Keelung City 202', '202 基隆市中正区'] },
			203: { name: ['203 基隆市中山區', 'Zhong Shan District, Keelung City 203', '203 基隆市中山区'] },
			204: { name: ['204 基隆市安樂區', 'An Le District, Keelung City 204', '204 基隆市安乐区'] },
			205: { name: ['205 基隆市暖暖區', 'Nuan Nuan District, Keelung City 205', '205 基隆市暖暖区'] },
			206: { name: ['206 基隆市七堵區', 'Qi Du District, Keelung City 206', '206 基隆市七堵区'] }
		}
	},
	'11': {
		name: ['台北市', 'Taipei City', '台北市'],
		children: {
			100: { name: ['100 台北市中正區', 'Zhong Zheng District, Taipei City 100', '100 台北市中正区'] },
			103: { name: ['103 台北市大同區', 'Da Tong District, Taipei City 103', '103 台北市大同区'] },
			104: { name: ['104 台北市中山區', 'Zhong Shan District, Taipei City 104', '104 台北市中山区'] },
			105: { name: ['105 台北市松山區', 'Song Shan District, Taipei City 105', '105 台北市松山区'] },
			106: { name: ['106 台北市大安區', 'Da An District, Taipei City 106', '106 台北市大安区'] },
			108: { name: ['108 台北市萬華區', 'Wan Hua District, Taipei City 108', '108 台北市万华区'] },
			110: { name: ['110 台北市信義區', 'Xin Yi District, Taipei City 110', '110 台北市信义区'] },
			111: { name: ['111 台北市士林區', 'Shi Lin District, Taipei City 111', '111 台北市士林区'] },
			112: { name: ['112 台北市北投區', 'Bei Tou District, Taipei City 112', '112 台北市北投区'] },
			114: { name: ['114 台北市內湖區', 'Nei Hu District, Taipei City 114', '114 台北市内湖区'] },
			115: { name: ['115 台北市南港區', 'Nan Gang District, Taipei City 115', '115 台北市南港区'] },
			116: { name: ['116 台北市文山區', 'Wen Shan District, Taipei City 116', '116 台北市文山区'] }
		}
	},
	'12': {
		name: ['新北市', 'New Taipei City', '新北市'],
		children: {
			207: { name: ['207 新北市萬里區', 'Wan Li Village, New Taipei City 207', '207 新北市万里区'] },
			208: { name: ['208 新北市金山區', 'Jin Shan Village, New Taipei City 208', '208 新北市金山区'] },
			220: { name: ['220 新北市板橋區', 'Ban Qiao City, New Taipei City 220', '220 新北市板桥区'] },
			221: { name: ['221 新北市汐止區', 'Xi Zhi City, New Taipei City 221', '221 新北市汐止区'] },
			222: { name: ['222 新北市深坑區', 'Shen Keng Village, New Taipei City 222', '222 新北市深坑区'] },
			223: { name: ['223 新北市石碇區', 'Shi Ding Village, New Taipei City 223', '223 新北市石碇区'] },
			224: { name: ['224 新北市瑞芳區', 'Rui Fang Township, New Taipei City 224', '224 新北市瑞芳区'] },
			226: { name: ['226 新北市平溪區', 'Ping Xi Village, New Taipei City 226', '226 新北市平溪区'] },
			227: { name: ['227 新北市雙溪區', 'Shuang Xi Village, New Taipei City 227', '227 新北市双溪区'] },
			228: { name: ['228 新北市貢寮區', 'Gong Liao Village, New Taipei City 228', '228 新北市贡寮区'] },
			231: { name: ['231 新北市新店區', 'Xin Dian City, New Taipei City 231', '231 新北市新店区'] },
			232: { name: ['232 新北市坪林區', 'Ping Lin Village, New Taipei City 232', '232 新北市坪林区'] },
			233: { name: ['233 新北市烏來區', 'Wu Lai Village, New Taipei City 233', '233 新北市乌来区'] },
			234: { name: ['234 新北市永和區', 'Yong He City, New Taipei City 234', '234 新北市永和区'] },
			235: { name: ['235 新北市中和區', 'Zhong He City, New Taipei City 235', '235 新北市中和区'] },
			236: { name: ['236 新北市土城區', 'Tu Chen City, New Taipei City 236', '236 新北市土城区'] },
			237: { name: ['237 新北市三峽區', 'San Xia Township, New Taipei City 237', '237 新北市三峡区'] },
			238: { name: ['238 新北市樹林區', 'Shu Lin City, New Taipei City 238', '238 新北市树林区'] },
			239: { name: ['239 新北市鶯歌區', 'Ying Ge Township, New Taipei City 239', '239 新北市莺歌区'] },
			241: { name: ['241 新北市三重區', 'San Zhong City, New Taipei City 241', '241 新北市三重区'] },
			242: { name: ['242 新北市新莊區', 'Xin Zhuang City, New Taipei City 242', '242 新北市新庄区'] },
			243: { name: ['243 新北市泰山區', 'Tai Shan Village, New Taipei City 243', '243 新北市泰山区'] },
			244: { name: ['244 新北市林口區', 'Lin Kou Village, New Taipei City 244', '244 新北市林口区'] },
			247: { name: ['247 新北市蘆洲區', 'Lu Zhou City, New Taipei City 247', '247 新北市芦洲区'] },
			248: { name: ['248 新北市五股區', 'Wu Gu Village, New Taipei City 248', '248 新北市五股区'] },
			249: { name: ['249 新北市八里區', 'Ba Li Village, New Taipei City 249', '249 新北市八里区'] },
			251: { name: ['251 新北市淡水區', 'Tamshui Township, New Taipei City 251', '251 新北市淡水区'] },
			252: { name: ['252 新北市三芝區', 'San Zhi Village, New Taipei City 252', '252 新北市三芝区'] },
			253: { name: ['253 新北市石門區', 'Shi Men Village, New Taipei City 253', '253 新北市石门区'] }
		}
	},
	'13': {
		name: ['桃園市', 'Taoyuan County', '桃园市'],
		children: {
			320: { name: ['320 桃園市中壢區', 'Zhong Li City, Taoyuan County 320', '320 桃园市中坜区'] },
			324: { name: ['324 桃園市平鎮區', 'Ping Zhen City, Taoyuan County 324', '324 桃园市平镇区'] },
			325: { name: ['325 桃園市龍潭區', 'Long Tan Village, Taoyuan County 325', '325 桃园市龙潭区'] },
			326: { name: ['326 桃園市楊梅區', 'Yang Mei Township, Taoyuan County 326', '326 桃园市杨梅区'] },
			327: { name: ['327 桃園市新屋區', 'Xin Wu Village, Taoyuan County 327', '327 桃园市新屋区'] },
			328: { name: ['328 桃園市觀音區', 'Guan Yin Village, Taoyuan County 328', '328 桃园市观音区'] },
			330: { name: ['330 桃園市桃園區', 'Taoyuan City, Taoyuan County 330', '330 桃园市桃园区'] },
			333: { name: ['333 桃園市龜山區', 'Gui Shan Village, Taoyuan County 333', '333 桃园市龟山区'] },
			334: { name: ['334 桃園市八德區', 'Ba Teh City, Taoyuan County 334', '334 桃园市八德区'] },
			335: { name: ['335 桃園市大溪區', 'Da Xi Township, Taoyuan County 335', '335 桃园市大溪区'] },
			336: { name: ['336 桃園市復興區', 'Fu Xing Village, Taoyuan County 336', '336 桃园市复兴区'] },
			337: { name: ['337 桃園市大園區', 'Da Yuan Village, Taoyuan County 337', '337 桃园市大园区'] },
			338: { name: ['338 桃園市蘆竹區', 'Lu Zhu Village, Taoyuan County 338', '338 桃园市芦竹区'] }
		}
	},
	'14': {
		name: ['新竹市', 'Hsinchu City', '新竹市'],
		children: {
			300: { name: ['300 新竹市', 'Hsinchu City 300', '300 新竹市'] }
		}
	},
	'15': {
		name: ['新竹縣', 'Hsinchu County', '新竹县'],
		children: {
			302: { name: ['302 新竹縣竹北市', 'Zhubei City, Hsinchu County 302', '302 新竹县竹北市'] },
			303: { name: ['303 新竹縣湖口鄉', 'Hu Kou Village, Hsinchu County 303', '303 新竹县湖口乡'] },
			304: { name: ['304 新竹縣新豐鄉', 'Xin Feng Village, Hsinchu County 304', '304 新竹县新丰乡'] },
			305: { name: ['305 新竹縣新埔鎮', 'Xin Bu Township, Hsinchu County 305', '305 新竹县新埔镇'] },
			306: { name: ['306 新竹縣關西鎮', 'Guan Xi Township, Hsinchu County 306', '306 新竹县关西镇'] },
			307: { name: ['307 新竹縣芎林鄉', 'Qiong Lin Village, Hsinchu County 307', '307 新竹县芎林乡'] },
			308: { name: ['308 新竹縣寶山鄉', 'Bao Shan Village, Hsinchu County 308', '308 新竹县宝山乡'] },
			310: { name: ['310 新竹縣竹東鎮', 'Zhu Dong Township, Hsinchu County 310', '310 新竹县竹东镇'] },
			311: { name: ['311 新竹縣五峰鄉', 'Wu Feng Village, Hsinchu County 311', '311 新竹县五峰乡'] },
			312: { name: ['312 新竹縣橫山鄉', 'Heng Shan Village, Hsinchu County 312', '312 新竹县横山乡'] },
			313: { name: ['313 新竹縣尖石鄉', 'Jian Shi Village, Hsinchu County 313', '313 新竹县尖石乡'] },
			314: { name: ['314 新竹縣北埔鄉', 'Bei Bu Village, Hsinchu County 314', '314 新竹县北埔乡'] },
			315: { name: ['315 新竹縣峨眉鄉', 'E Mei Village, Hsinchu County 315', '315 新竹县峨眉乡'] }
		}
	},
	'16': {
		name: ['苗栗縣', 'Miaoli County', '苗栗县'],
		children: {
			350: { name: ['350 苗栗縣竹南鎮', 'Zhu Nan Township, Miaoli County 350', '350 苗栗县竹南镇'] },
			351: { name: ['351 苗栗縣頭份市', 'Tou Fen City, Miaoli County 351', '351 苗栗县头份市'] },
			352: { name: ['352 苗栗縣三灣鄉', 'San Wan Village, Miaoli County 352', '352 苗栗县三湾乡'] },
			353: { name: ['353 苗栗縣南庄鄉', 'Nan Zhuang Village, Miaoli County 353', '353 苗栗县南庄乡'] },
			354: { name: ['354 苗栗縣獅潭鄉', 'Shi Tan Village, Miaoli County 354', '354 苗栗县狮潭乡'] },
			356: { name: ['356 苗栗縣後龍鎮', 'Hou Long Township, Miaoli County 356', '356 苗栗县后龙镇'] },
			357: { name: ['357 苗栗縣通霄鎮', 'Tong Xiao Township, Miaoli County 357', '357 苗栗县通霄镇'] },
			358: { name: ['358 苗栗縣苑裡鎮', 'Yuan Li Township, Miaoli County 358', '358 苗栗县苑里镇'] },
			360: { name: ['360 苗栗縣苗栗市', 'Miaoli City, Miaoli County 360', '360 苗栗县苗栗市'] },
			361: { name: ['361 苗栗縣造橋鄉', 'Zao Qiao Village, Miaoli County 361', '361 苗栗县造桥乡'] },
			362: { name: ['362 苗栗縣頭屋鄉', 'Tou Wu Village, Miaoli County 362', '362 苗栗县头屋乡'] },
			363: { name: ['363 苗栗縣公館鄉', 'Gong Guan Village, Miaoli County 363', '363 苗栗县公馆乡'] },
			364: { name: ['364 苗栗縣大湖鄉', 'Da Hu Village, Miaoli County 364', '364 苗栗县大湖乡'] },
			365: { name: ['365 苗栗縣泰安鄉', 'Tai An Village, Miaoli County 365', '365 苗栗县泰安乡'] },
			366: { name: ['366 苗栗縣銅鑼鄉', 'Tong Luo Village, Miaoli County 366', '366 苗栗县铜锣乡'] },
			367: { name: ['367 苗栗縣三義鄉', 'San Yi Village, Miaoli County 367', '367 苗栗县三义乡'] },
			368: { name: ['368 苗栗縣西湖鄉', 'Xi Hu Village, Miaoli County 368', '368 苗栗县西湖乡'] },
			369: { name: ['369 苗栗縣卓蘭鎮', 'Zhuo Lan Township, Miaoli County 369', '369 苗栗县卓兰镇'] }
		}
	},
	'17': {
		name: ['台中市', 'Taichung City', '台中市'],
		children: {
			400: { name: ['400 台中市中區', 'Central District, Taichung City 400', '400 台中市中区'] },
			401: { name: ['401 台中市東區', 'East District, Taichung City 401', '401 台中市东区'] },
			402: { name: ['402 台中市南區', 'South District, Taichung City 402', '402 台中市南区'] },
			403: { name: ['403 台中市西區', 'West District, Taichung City 403', '403 台中市西区'] },
			404: { name: ['404 台中市北區', 'North District, Taichung City 404', '404 台中市北区'] },
			406: { name: ['406 台中市北屯區', 'Bei Tun District, Taichung City 406', '406 台中市北屯区'] },
			407: { name: ['407 台中市西屯區', 'Xi Tun District, Taichung City 407', '407 台中市西屯区'] },
			408: { name: ['408 台中市南屯區', 'Nan Tun District, Taichung City 408', '408 台中市南屯区'] },
			411: { name: ['411 台中市太平區', 'Tai Ping District, Taichung City 411', '411 台中市太平區'] },
			412: { name: ['412 台中市大里區', 'Da Li District, Taichung City 412', '412 台中市大里区'] },
			413: { name: ['413 台中市霧峰區', 'Wu Feng District, Taichung City 413', '413 台中市雾峰区'] },
			414: { name: ['414 台中市烏日區', 'Wu Ri District, Taichung City 414', '414 台中市乌日区'] },
			420: { name: ['420 台中市豐原區', 'Feng Yuan District, Taichung City 420', '420 台中市丰原区'] },
			421: { name: ['421 台中市后里區', 'Hou Li District, Taichung City 421', '421 台中市后里区'] },
			422: { name: ['422 台中市石岡區', 'Shi Gang District, Taichung City 422', '422 台中市石冈区'] },
			423: { name: ['423 台中市東勢區', 'Dong Shi District, Taichung City 423', '423 台中市东势区'] },
			424: { name: ['424 台中市和平區', 'He Ping District, Taichung City 424', '424 台中市和平区'] },
			426: { name: ['426 台中市新社區', 'Xin She District, Taichung City 426', '426 台中市新社区'] },
			427: { name: ['427 台中市潭子區', 'Tan Zi District, Taichung City 427', '427 台中市潭子区'] },
			428: { name: ['428 台中市大雅區', 'Da Ya District, Taichung City 428', '428 台中市大雅区'] },
			429: { name: ['429 台中市神岡區', 'Shen Gang District, Taichung City 429', '429 台中市神冈区'] },
			432: { name: ['432 台中市大肚區', 'Da Du District, Taichung City 432', '432 台中市大肚区'] },
			433: { name: ['433 台中市沙鹿區', 'Sha Lu District, Taichung City 433', '433 台中市沙鹿区'] },
			434: { name: ['434 台中市龍井區', 'Long Jing District, Taichung City 434', '434 台中市龙井区'] },
			435: { name: ['435 台中市梧棲區', 'Wu Qi District, Taichung City 435', '435 台中市梧栖区'] },
			436: { name: ['436 台中市清水區', 'Qing Shui District, Taichung City 436', '436 台中市清水区'] },
			437: { name: ['437 台中市大甲區', 'Da Jia District, Taichung City 437', '437 台中市大甲区'] },
			438: { name: ['438 台中市外埔區', 'Wai Bu District, Taichung City 438', '438 台中市外埔区'] },
			439: { name: ['439 台中市大安區', 'Da An District, Taichung City 439', '439 台中市大安区'] }
		}
	},
	'18': {
		name: ['彰化縣', 'Changhua County', '彰化县'],
		children: {
			500: { name: ['500 彰化縣彰化市', 'Changhua City, Changhua County 500', '500 彰化县彰化市'] },
			502: { name: ['502 彰化縣芬園鄉', 'Fen Yuan Village, Changhua County 502', '502 彰化县芬园乡'] },
			503: { name: ['503 彰化縣花壇鄉', 'Hua Tan Village, Changhua County 503', '503 彰化县花坛乡'] },
			504: { name: ['504 彰化縣秀水鄉', 'Xiu Shui Village, Changhua County 504', '504 彰化县秀水乡'] },
			505: { name: ['505 彰化縣鹿港鎮', 'Lu Gang Township, Changhua County 505', '505 彰化县鹿港镇'] },
			506: { name: ['506 彰化縣福興鄉', 'Fu Xing Village, Changhua County 506', '506 彰化县福兴乡'] },
			507: { name: ['507 彰化縣線西鄉', 'Xian Xi Village, Changhua County 507', '507 彰化县线西乡'] },
			508: { name: ['508 彰化縣和美鎮', 'He Mei Township, Changhua County 508', '508 彰化县和美镇'] },
			509: { name: ['509 彰化縣伸港鄉', 'Shen Gang Village, Changhua County 509', '509 彰化县伸港乡'] },
			510: { name: ['510 彰化縣員林市', 'Yuan Lin City, Changhua County 510', '510 彰化县员林市'] },
			511: { name: ['511 彰化縣社頭鄉', 'She Tou Village, Changhua County 511', '511 彰化县社头乡'] },
			512: { name: ['512 彰化縣永靖鄉', 'Yong Jing Village, Changhua County 512', '512 彰化县永靖乡'] },
			513: { name: ['513 彰化縣埔心鄉', 'Bu Xin Village, Changhua County 513', '513 彰化县埔心乡'] },
			514: { name: ['514 彰化縣溪湖鎮', 'Xi Hu Township, Changhua County 514', '514 彰化县溪湖镇'] },
			515: { name: ['515 彰化縣大村鄉', 'Da Cun Village, Changhua County 515', '515 彰化县大村乡'] },
			516: { name: ['516 彰化縣埔鹽鄉', 'Bu Yan Village, Changhua County 516', '516 彰化县埔盐乡'] },
			520: { name: ['520 彰化縣田中鎮', 'Tian Zhong Township, Changhua County 520', '520 彰化县田中镇'] },
			521: { name: ['521 彰化縣北斗鎮', 'Bei Dou Township, Changhua County 521', '521 彰化县北斗镇'] },
			522: { name: ['522 彰化縣田尾鄉', 'Tian Wei Village, Changhua County 522', '522 彰化县田尾乡'] },
			523: { name: ['523 彰化縣埤頭鄉', 'Bi Tou Village, Changhua County 523', '523 彰化县埤头乡'] },
			524: { name: ['524 彰化縣溪州鄉', 'Xi Zhou Village, Changhua County 524', '524 彰化县溪州乡'] },
			525: { name: ['525 彰化縣竹塘鄉', 'Zhu Tang Village, Changhua County 525', '525 彰化县竹塘乡'] },
			526: { name: ['526 彰化縣二林鎮', 'Er Lin Township, Changhua County 526', '526 彰化县二林镇'] },
			527: { name: ['527 彰化縣大城鄉', 'Da Cheng Village, Changhua County 527', '527 彰化县大城乡'] },
			528: { name: ['528 彰化縣芳苑鄉', 'Fang Yuan Village, Changhua County 528', '528 彰化县芳苑乡'] },
			530: { name: ['530 彰化縣二水鄉', 'Er Shui Village, Changhua County 530', '530 彰化县二水乡'] }
		}
	},
	'19': {
		name: ['南投縣', 'Nantou County', '南投县'],
		children: {
			540: { name: ['540 南投縣南投市', 'Nantou City, Nantou County 540', '540 南投县南投市'] },
			541: { name: ['541 南投縣中寮鄉', 'Zhong Liao Village, Nantou County 541', '541 南投县中寮乡'] },
			542: { name: ['542 南投縣草屯鎮', 'Cao Tun Township, Nantou County 542', '542 南投县草屯镇'] },
			544: { name: ['544 南投縣國姓鄉', 'Guo Xing Village, Nantou County 544', '544 南投县国姓乡'] },
			545: { name: ['545 南投縣埔里鎮', 'Bu Li Township, Nantou County 545', '545 南投县埔里镇'] },
			546: { name: ['546 南投縣仁愛鄉', 'Ren Ai Village, Nantou County 546', '546 南投县仁爱乡'] },
			551: { name: ['551 南投縣名間鄉', 'Ming Jian Village, Nantou County 551', '551 南投县名间乡'] },
			552: { name: ['552 南投縣集集鎮', 'Ji Ji Township, Nantou County 552', '552 南投县集集镇'] },
			553: { name: ['553 南投縣水里鄉', 'Shui Li Village, Nantou County 553', '553 南投县水里乡'] },
			555: { name: ['555 南投縣魚池鄉', 'Yu Chi Village, Nantou County 555', '555 南投县鱼池乡'] },
			556: { name: ['556 南投縣信義鄉', 'Xin Yi Village, Nantou County 556', '556 南投县信义乡'] },
			557: { name: ['557 南投縣竹山鎮', 'Zhu Shan Township, Nantou County 557', '557 南投县竹山镇'] },
			558: { name: ['558 南投縣鹿谷鄉', 'Lu Gu Village, Nantou County 558', '558 南投县鹿谷乡'] }
		}
	},
	'20': {
		name: ['雲林縣', 'Yunlin County', '云林县'],
		children: {
			630: { name: ['630 雲林縣斗南鎮', 'Dou Nan Township, Yunlin County 630', '630 云林县斗南镇'] },
			631: { name: ['631 雲林縣大埤鄉', 'Da Bi Village, Yunlin County 631', '631 云林县大埤乡'] },
			632: { name: ['632 雲林縣虎尾鎮', 'Hu Wei Township, Yunlin County 632', '632 云林县虎尾镇'] },
			633: { name: ['633 雲林縣土庫鎮', 'Tu Ku Township, Yunlin County 633', '633 云林县土库镇'] },
			634: { name: ['634 雲林縣褒忠鄉', 'Bao Zhong Village, Yunlin County 634', '634 云林县褒忠乡'] },
			635: { name: ['635 雲林縣東勢鄉', 'Dong Shi Village, Yunlin County 635', '635 云林县东势乡'] },
			636: { name: ['636 雲林縣台西鄉', 'Tai Xi Village, Yunlin County 636', '636 云林县台西乡'] },
			637: { name: ['637 雲林縣崙背鄉', 'Lun Bei Village, Yunlin County 637', '637 云林县仑背乡'] },
			638: { name: ['638 雲林縣麥寮鄉', 'Mai Liao Village, Yunlin County 638', '638 云林县麦寮乡'] },
			640: { name: ['640 雲林縣斗六市', 'Dou Liu City, Yunlin County 640', '640 云林县斗六市'] },
			643: { name: ['643 雲林縣林內鄉', 'Lin Nei Village, Yunlin County 643', '643 云林县林内乡'] },
			646: { name: ['646 雲林縣古坑鄉', 'Gu Keng Village, Yunlin County 646', '646 云林县古坑乡'] },
			647: { name: ['647 雲林縣莿桐鄉', 'Ci Tong Village, Yunlin County 647 ', '647 云林县莿桐乡'] },
			648: { name: ['648 雲林縣西螺鎮', 'Xi Luo Township, Yunlin County 648', '648 云林县西螺镇'] },
			649: { name: ['649 雲林縣二崙鄉', 'Er Lun Village, Yunlin County 649', '649 云林县二仑乡'] },
			651: { name: ['651 雲林縣北港鎮', 'Bei Gang Township, Yunlin County 651', '651 云林县北港镇'] },
			652: { name: ['652 雲林縣水林鄉', 'Shui Lin Village, Yunlin County 652', '652 云林县水林乡'] },
			653: { name: ['653 雲林縣口湖鄉', 'Kou Hu Village, Yunlin County 653', '653 云林县口湖乡'] },
			654: { name: ['654 雲林縣四湖鄉', 'Si Hu Village, Yunlin County 654', '654 云林县四湖乡'] },
			655: { name: ['655 雲林縣元長鄉', 'Yuan Chang Village, Yunlin County 655', '655 云林县元长乡'] }
		}
	},
	'21': {
		name: ['嘉義市', 'Chiayi City', '嘉义市'],
		children: {
			600: { name: ['600 嘉義市', 'Chiayi City 600', '600 嘉义市'] }
		}
	},
	'22': {
		name: ['嘉義縣', 'Chiayi County', '嘉义县'],
		children: {
			602: { name: ['602 嘉義縣番路鄉', 'Fan Lu Village, Chiayi County 602', '602 嘉义县番路乡'] },
			603: { name: ['603 嘉義縣梅山鄉', 'Mei Shan Village, Chiayi County 603', '603 嘉义县梅山乡'] },
			604: { name: ['604 嘉義縣竹崎鄉', 'Zhu Qi Village, Chiayi County 604', '604 嘉义县竹崎乡'] },
			605: { name: ['605 嘉義縣阿里山鄉', 'The Chiayi County A Li Shan Village 605', '605 嘉义县阿里山乡'] },
			606: { name: ['606 嘉義縣中埔鄉', 'Zhong Bu Village, Chiayi County 606', '606 嘉义县中埔乡'] },
			607: { name: ['607 嘉義縣大埔鄉', 'Da Bu Village, Chiayi County 607', '607 嘉义县大埔乡'] },
			608: { name: ['608 嘉義縣水上鄉', 'Shui Shang Village, Chiayi County 608', '608 嘉义县水上乡'] },
			611: { name: ['611 嘉義縣鹿草鄉', 'Lu Cao Village, Chiayi County 611', '611 嘉义县鹿草乡'] },
			612: { name: ['612 嘉義縣太保市', 'Tai Bao City, Chiayi County 612', '612 嘉义县太保市'] },
			613: { name: ['613 嘉義縣朴子市', 'Pu Zi City, Chiayi County 613', '613 嘉义县朴子市'] },
			614: { name: ['614 嘉義縣東石鄉', 'Dong Shi Village, Chiayi County 614', '614 嘉义县东石乡'] },
			615: { name: ['615 嘉義縣六腳鄉', 'Liu Jiao Village, Chiayi County 615', '615 嘉义县六脚乡'] },
			616: { name: ['616 嘉義縣新港鄉', 'Xin Gang Village, Chiayi County 616', '616 嘉义县新港乡'] },
			621: { name: ['621 嘉義縣民雄鄉', 'Min Xiong Village, Chiayi County 621', '621 嘉义县民雄乡'] },
			622: { name: ['622 嘉義縣大林鎮', 'Da Lin Township, Chiayi County 622', '622 嘉义县大林镇'] },
			623: { name: ['623 嘉義縣溪口鄉', 'Xi Kou Village, Chiayi County 623', '623 嘉义县溪口乡'] },
			624: { name: ['624 嘉義縣義竹鄉', 'Yi Zhu Village, Chiayi County 624', '624 嘉义县义竹乡'] },
			625: { name: ['625 嘉義縣布袋鎮', 'Bu Dai Township, Chiayi County 625', '625 嘉义县布袋镇'] }
		}
	},
	'23': {
		name: ['台南市', 'Tainan City', '台南市'],
		children: {
			700: { name: ['700 台南市中西區', 'Zhong Xi District, Tainan City 700', '700 台南市中西区'] },
			701: { name: ['701 台南市東區', 'East District, Tainan City 701', '701 台南市东区'] },
			702: { name: ['702 台南市南區', 'South District, Tainan City 702', '702 台南市南区'] },
			704: { name: ['704 台南市北區', 'North District, Tainan City 704', '704 台南市北区'] },
			708: { name: ['708 台南市安平區', 'An Ping District, Tainan City 708', '708 台南市安平区'] },
			709: { name: ['709 台南市安南區', 'An Nan District, Tainan City 709', '709 台南市安南区'] },
			710: { name: ['710 台南市永康區', 'Yong Kang District, Tainan City 710', '710 台南市永康区'] },
			711: { name: ['711 台南市歸仁區', 'Gui Ren District, Tainan City 711', '711 台南市归仁区'] },
			712: { name: ['712 台南市新化區', 'Xin Hua District, Tainan City 712', '712 台南市新化区'] },
			713: { name: ['713 台南市左鎮區', 'Zuo Zhen District, Tainan City 713', '713 台南市左镇区'] },
			714: { name: ['714 台南市玉井區', 'Yu Jing District, Tainan City 714', '714 台南市玉井区'] },
			715: { name: ['715 台南市楠西區', 'Nan Xi District, Tainan City 715', '715 台南市楠西区'] },
			716: { name: ['716 台南市南化區', 'Nan Hua District, Tainan City 716', '716 台南市南化区'] },
			717: { name: ['717 台南市仁德區', 'Ren Teh District, Tainan City 717', '717 台南市仁德区'] },
			718: { name: ['718 台南市關廟區', 'Guan Miao District, Tainan City 718', '718 台南市关庙区'] },
			719: { name: ['719 台南市龍崎區', 'Long Qi District, Tainan City 719', '719 台南市龙崎区'] },
			720: { name: ['720 台南市官田區', 'Guan Tian District, Tainan City 720', '720 台南市官田区'] },
			721: { name: ['721 台南市麻豆區', 'Ma Dou District, Tainan City 721', '721 台南市麻豆区'] },
			722: { name: ['722 台南市佳里區', 'Jia Li District, Tainan City 722', '722 台南市佳里区'] },
			723: { name: ['723 台南市西港區', 'Xi Gang District, Tainan City 723', '723 台南市西港区'] },
			724: { name: ['724 台南市七股區', 'Qi Gu District, Tainan City 724', '724 台南市七股区'] },
			725: { name: ['725 台南市將軍區', 'Jiang Jun District, Tainan City 725', '725 台南市将军区'] },
			726: { name: ['726 台南市學甲區', 'Xue Jia District, Tainan City 726', '726 台南市学甲区'] },
			727: { name: ['727 台南市北門區', 'Bei Men District, Tainan City 727', '727 台南市北门区'] },
			730: { name: ['730 台南市新營區', 'Xin Ying District, Tainan City 730', '730 台南市新营区'] },
			731: { name: ['731 台南市後壁區', 'Hou Bi District, Tainan City 731', '731 台南市后壁区'] },
			732: { name: ['732 台南市白河區', 'Bai He District, Tainan City 732', '732 台南市白河区'] },
			733: { name: ['733 台南市東山區', 'Dong Shan District, Tainan City 733', '733 台南市东山区'] },
			734: { name: ['734 台南市六甲區', 'Liu Jia District, Tainan City 734', '734 台南市六甲区'] },
			735: { name: ['735 台南市下營區', 'Xia Ying District, Tainan City 735', '735 台南市下营区'] },
			736: { name: ['736 台南市柳營區', 'Liu Ying District, Tainan City 736', '736 台南市柳营区'] },
			737: { name: ['737 台南市鹽水區', 'Yan Shui District, Tainan City 737', '737 台南市盐水区'] },
			741: { name: ['741 台南市善化區', 'Shan Hua District, Tainan City 741', '741 台南市善化区'] },
			742: { name: ['742 台南市大內區', 'Da Nei District, Tainan City 742', '742 台南市大内区'] },
			743: { name: ['743 台南市山上區', 'Shan Shang District, Tainan City 743', '743 台南市山上区'] },
			744: { name: ['744 台南市新市區', 'Xin Shi District, Tainan City 744', '744 台南市新市区'] },
			745: { name: ['745 台南市安定區', 'An Ding District, Tainan City 745', '745 台南市安定区'] }
		}
	},
	'24': {
		name: ['高雄市', 'Kaohsiung City', '高雄市'],
		children: {
			800: { name: ['800 高雄市新興區', 'Xin Xing District, Kaohsiung City 800', '800 高雄市新兴区'] },
			801: { name: ['801 高雄市前金區', 'Qian Jin District, Kaohsiung City 801', '801 高雄市前金区'] },
			802: { name: ['802 高雄市苓雅區', 'Ling Ya District, Kaohsiung City 802', '802 高雄市苓雅区'] },
			803: { name: ['803 高雄市鹽埕區', 'Yan Cheng District, Kaohsiung City 803', '803 高雄市盐埕区'] },
			804: { name: ['804 高雄市鼓山區', 'Gu Shan District, Kaohsiung City 804', '804 高雄市鼓山区'] },
			805: { name: ['805 高雄市旗津區', 'Qi Jin District, Kaohsiung City 805', '805 高雄市旗津区'] },
			806: { name: ['806 高雄市前鎮區', 'Qianzhen District, Kaohsiung City 806', '806 高雄市前镇区'] },
			807: { name: ['807 高雄市三民區', 'San Min District, Kaohsiung City 807', '807 高雄市三民区'] },
			811: { name: ['811 高雄市楠梓區', 'Nan Zi District, Kaohsiung City 811', '811 高雄市楠梓区'] },
			812: { name: ['812 高雄市小港區', 'Xiao Gang District, Kaohsiung City 812', '812 高雄市小港区'] },
			813: { name: ['813 高雄市左營區', 'Zuo Ying District, Kaohsiung City 813', '813 高雄市左营区'] },
			814: { name: ['814 高雄市仁武區', 'Ren Wu District, Kaohsiung City 814', '814 高雄市仁武区'] },
			815: { name: ['815 高雄市大社區', 'Da She District, Kaohsiung City 815', '815 高雄市大社区'] },
			817: { name: ['817 高雄市東沙群島', 'Dongsha Islands, Nanhai Islands, Kaohsiung City 817', '817 高雄市东沙群岛'] },
			819: { name: ['819 高雄市南沙群島', 'Nansha Islands, Nanhai Islands, Kaohsiung City 819', '819 高雄市南沙群岛'] },
			820: { name: ['820 高雄市岡山區', 'Gang Shan District, Kaohsiung City 820', '820 高雄市冈山区'] },
			821: { name: ['821 高雄市路竹區', 'Lu Zhu District, Kaohsiung City 821', '821 高雄市路竹区'] },
			822: { name: ['822 高雄市阿蓮區', 'A Lian District, Kaohsiung City 822', '822 高雄市阿莲区'] },
			823: { name: ['823 高雄市田寮區', 'Tian Liao District, Kaohsiung City 823', '823 高雄市田寮区'] },
			824: { name: ['824 高雄市燕巢區', 'Yan Chao District, Kaohsiung City 824', '824 高雄市燕巢区'] },
			825: { name: ['825 高雄市橋頭區', 'Qiao Tou District, Kaohsiung City 825', '825 高雄市桥头区'] },
			826: { name: ['826 高雄市梓官區', 'Zi Guan District, Kaohsiung City 826', '826 高雄市梓官区'] },
			827: { name: ['827 高雄市彌陀區', 'Mi Tuo District, Kaohsiung City 827', '827 高雄市弥陀区'] },
			828: { name: ['828 高雄市永安區', 'Yong An District, Kaohsiung City 828', '828 高雄市永安区'] },
			829: { name: ['829 高雄市湖內區', 'Hu Nei District, Kaohsiung City 829', '829 高雄市湖内区'] },
			830: { name: ['830 高雄市鳳山區', 'Feng Shan City, Kaohsiung City 830', '830 高雄市凤山区'] },
			831: { name: ['831 高雄市大寮區', 'Da Liao District, Kaohsiung City 831', '831 高雄市大寮区'] },
			832: { name: ['832 高雄市林園區', 'Lin Yuan District, Kaohsiung City 832', '832 高雄市林园区'] },
			833: { name: ['833 高雄市鳥松區', 'Niao Song District, Kaohsiung City 833', '833 高雄市鸟松区'] },
			840: { name: ['840 高雄市大樹區', 'Da Shu District, Kaohsiung City 840', '840 高雄市大树区'] },
			842: { name: ['842 高雄市旗山區', 'Qi Shan District, Kaohsiung City 842', '842 高雄市旗山区'] },
			843: { name: ['843 高雄市美濃區', 'Mei Nong District, Kaohsiung City 843', '843 高雄市美浓区'] },
			844: { name: ['844 高雄市六龜區', 'Liu Gui District, Kaohsiung City 844', '844 高雄市六龟区'] },
			845: { name: ['845 高雄市內門區', 'Nei Men District, Kaohsiung City 845', '845 高雄市内门区'] },
			846: { name: ['846 高雄市杉林區', 'Shan Lin District, Kaohsiung City 846', '846 高雄市杉林区'] },
			847: { name: ['847 高雄市甲仙區', 'Jia Xian District, Kaohsiung City 847', '847 高雄市甲仙区'] },
			848: { name: ['848 高雄市桃源區', 'Tao Yuan District, Kaohsiung City 848', '848 高雄市桃源区'] },
			849: { name: ['849 高雄市那瑪夏區', 'San Min District, Kaohsiung City 849', '849 高雄市那玛夏区'] },
			851: { name: ['851 高雄市茂林區', 'Mao Lin District, Kaohsiung City 851', '851 高雄市茂林区'] },
			852: { name: ['852 高雄市茄萣區', 'Jia Ding District, Kaohsiung City 852', '852 高雄市茄萣区'] }
		}
	},
	'25': {
		name: ['屏東縣', 'Pingtung County', '屏东县'],
		children: {
			900: { name: ['900 屏東縣屏東市', 'Pingtung City, Pingtung County 900', '900 屏东县屏东市'] },
			901: { name: ['901 屏東縣三地門鄉', 'Pingtung County San Di Men Village 901', '901 屏东县三地门乡'] },
			902: { name: ['902 屏東縣霧台鄉', 'Wu Tai Village, Pingtung County 902', '902 屏东县雾台乡'] },
			903: { name: ['903 屏東縣瑪家鄉', 'Ma Jia Village, Pingtung County 903', '903 屏东县玛家乡'] },
			904: { name: ['904 屏東縣九如鄉', 'Jiu Ru Village, Pingtung County 904', '904 屏东县九如乡'] },
			905: { name: ['905 屏東縣里港鄉', 'Li Gang Village, Pingtung County 905', '905 屏东县里港乡'] },
			906: { name: ['906 屏東縣高樹鄉', 'Gao Shu Village, Pingtung County 906', '906 屏东县高树乡'] },
			907: { name: ['907 屏東縣鹽埔鄉', 'Yan Bu Village, Pingtung County 907', '907 屏东县盐埔乡'] },
			908: { name: ['908 屏東縣長治鄉', 'Chang Zhi Village, Pingtung County 908', '908 屏东县长治乡'] },
			909: { name: ['909 屏東縣麟洛鄉', 'Lin Luo Village, Pingtung County 909', '909 屏东县麟洛乡'] },
			911: { name: ['911 屏東縣竹田鄉', 'Zhu Tian Village, Pingtung County 911', '911 屏东县竹田乡'] },
			912: { name: ['912 屏東縣內埔鄉', 'Nei Bu Village, Pingtung County 912', '912 屏东县内埔乡'] },
			913: { name: ['913 屏東縣萬丹鄉', 'Wan Dan Village, Pingtung County 913', '913 屏东县万丹乡'] },
			920: { name: ['920 屏東縣潮州鎮', 'Chao Zhou Township, Pingtung County 920', '920 屏东县潮州镇'] },
			921: { name: ['921 屏東縣泰武鄉', 'Tai Wu Village, Pingtung County 921', '921 屏东县泰武乡'] },
			922: { name: ['922 屏東縣來義鄉', 'Lai Yi Village, Pingtung County 922', '922 屏东县来义乡'] },
			923: { name: ['923 屏東縣萬巒鄉', 'Wan Luan Village, Pingtung County 923', '923 屏东县万峦乡'] },
			924: { name: ['924 屏東縣崁頂鄉', 'Kan Ding Village, Pingtung County 924', '924 屏东县崁顶乡'] },
			925: { name: ['925 屏東縣新埤鄉', 'Xin Bi Village, Pingtung County 925', '925 屏东县新埤乡'] },
			926: { name: ['926 屏東縣南州鄉', 'Nan Zhou Village, Pingtung County 926', '926 屏东县南州乡'] },
			927: { name: ['927 屏東縣林邊鄉', 'Lin Bian Village, Pingtung County 927', '927 屏东县林边乡'] },
			928: { name: ['928 屏東縣東港鎮', 'Dong Gang Township, Pingtung County 928', '928 屏东县东港镇'] },
			929: { name: ['929 屏東縣琉球鄉', 'Liu Qiu Village, Pingtung County 929', '929 屏东县琉球乡'] },
			931: { name: ['931 屏東縣佳冬鄉', 'Jia Dong Village, Pingtung County 931', '931 屏东县佳冬乡'] },
			932: { name: ['932 屏東縣新園鄉', 'Xin Yuan Village, Pingtung County 932', '932 屏东县新园乡'] },
			940: { name: ['940 屏東縣枋寮鄉', 'Fang Liao Village, Pingtung County 940', '940 屏东县枋寮乡'] },
			941: { name: ['941 屏東縣枋山鄉', 'Fang Shan Village, Pingtung County 941', '941 屏东县枋山乡'] },
			942: { name: ['942 屏東縣春日鄉', 'Chun Ri Village, Pingtung County 942', '942 屏东县春日乡'] },
			943: { name: ['943 屏東縣獅子鄉', 'Shi Zi Village, Pingtung County 943', '943 屏东县狮子乡'] },
			944: { name: ['944 屏東縣車城鄉', 'Che Cheng Village, Pingtung County 944', '944 屏东县车城乡'] },
			945: { name: ['945 屏東縣牡丹鄉', 'Mu Dan Village, Pingtung County 945', '945 屏东县牡丹乡'] },
			946: { name: ['946 屏東縣恆春鎮', 'Heng Chun Township, Pingtung County 946', '946 屏东县恒春镇'] },
			947: { name: ['947 屏東縣滿洲鄉', 'Man Zhou Village, Pingtung County 947', '947 屏东县满洲乡'] }
		}
	},
	'26': {
		name: ['台東縣', 'Taitung County', '台东县'],
		children: {
			950: { name: ['950 台東縣台東市', 'Taitung City, Taitung County 950', '950 台东县台东市'] },
			951: { name: ['951 台東縣綠島鄉', 'Lyu Dao Village, Taitung County 951', '951 台东县绿岛乡'] },
			952: { name: ['952 台東縣蘭嶼鄉', 'Lan Yu Village, Taitung County 952', '952 台东县兰屿乡'] },
			953: { name: ['953 台東縣延平鄉', 'Yan Ping Village, Taitung County 953', '953 台东县延平乡'] },
			954: { name: ['954 台東縣卑南鄉', 'Bei Nan Village, Taitung County 954', '954 台东县卑南乡'] },
			955: { name: ['955 台東縣鹿野鄉', 'Lu Ye Village, Taitung County 955', '955 台东县鹿野乡'] },
			956: { name: ['956 台東縣關山鎮', 'Guan Shan Township, Taitung County 956', '956 台东县关山镇'] },
			957: { name: ['957 台東縣海端鄉', 'Hai Duan Village, Taitung County 957', '957 台东县海端乡'] },
			958: { name: ['958 台東縣池上鄉', 'Chi Shang Village, Taitung County 958', '958 台东县池上乡'] },
			959: { name: ['959 台東縣東河鄉', 'Dong He Village, Taitung County 959', '959 台东县东河乡'] },
			961: { name: ['961 台東縣成功鎮', 'Cheng Gong Township, Taitung County 961', '961 台东县成功镇'] },
			962: { name: ['962 台東縣長濱鄉', 'Chang Bin Village, Taitung County 962', '962 台东县长滨乡'] },
			963: { name: ['963 台東縣太麻里鄉', 'The Taitung County Tai Ma Li Village 963', '963 台东县太麻里乡'] },
			964: { name: ['964 台東縣金峰鄉', 'Jin Feng Village, Taitung County 964', '964 台东县金峰乡'] },
			965: { name: ['965 台東縣大武鄉', 'Da Wu Village, Taitung County 965', '965 台东县大武乡'] },
			966: { name: ['966 台東縣達仁鄉', 'Da Ren Village, Taitung County 966', '966 台东县达仁乡'] }
		}
	},
	'27': {
		name: ['花蓮縣', 'Hualien County', '花莲县'],
		children: {
			970: { name: ['970 花蓮縣花蓮市', 'Hualien City, Hualien County 970', '970 花莲县花莲市'] },
			971: { name: ['971 花蓮縣新城鄉', 'Xin Cheng Village, Hualien County 971', '971 花莲县新城乡'] },
			972: { name: ['972 花蓮縣秀林鄉', 'Xiu Lin Village, Hualien County 972', '972 花莲县秀林乡'] },
			973: { name: ['973 花蓮縣吉安鄉', 'Ji An Village, Hualien County 973', '973 花莲县吉安乡'] },
			974: { name: ['974 花蓮縣壽豐鄉', 'Shou Feng Village, Hualien County 974', '974 花莲县寿丰乡'] },
			975: { name: ['975 花蓮縣鳳林鎮', 'Feng Lin Township, Hualien County 975', '975 花莲县凤林镇'] },
			976: { name: ['976 花蓮縣光復鄉', 'Guang Fu Village, Hualien County 976', '976 花莲县光复乡'] },
			977: { name: ['977 花蓮縣豐濱鄉', 'Feng Bin Village, Hualien County 977', '977 花莲县丰滨乡'] },
			978: { name: ['978 花蓮縣瑞穗鄉', 'Rui Sui Village, Hualien County 978', '978 花莲县瑞穗乡'] },
			979: { name: ['979 花蓮縣萬榮鄉', 'Wan Rong Village, Hualien County 979', '979 花莲县万荣乡'] },
			981: { name: ['981 花蓮縣玉里鎮', 'Yu Li Township, Hualien County 981', '981 花莲县玉里镇'] },
			982: { name: ['982 花蓮縣卓溪鄉', 'Zhuo Xi Village, Hualien County 982', '982 花莲县卓溪乡'] },
			983: { name: ['983 花蓮縣富里鄉', 'Fu Li Village, Hualien County 983', '983 花莲县富里乡'] }
		}
	},
	'28': {
		name: ['宜蘭縣', 'Yilan County', '宜兰县'],
		children: {
			260: { name: ['260 宜蘭縣宜蘭市', 'Yilan City, Yilan County 260', '260 宜兰县宜兰市'] },
			261: { name: ['261 宜蘭縣頭城鎮', 'Tou Cheng Township, Yilan County 261', '261 宜兰县头城镇'] },
			262: { name: ['262 宜蘭縣礁溪鄉', 'Jiao Xi Village, Yilan County 262', '262 宜兰县礁溪乡'] },
			263: { name: ['263 宜蘭縣壯圍鄉', 'Zhuang Wei Village, Yilan County 263', '263 宜兰县壮围乡'] },
			264: { name: ['264 宜蘭縣員山鄉', 'Yuan Shan Village, Yilan County 264', '264 宜兰县员山乡'] },
			265: { name: ['265 宜蘭縣羅東鎮', 'Luo Dong Township, Yilan County 265', '265 宜兰县罗东镇'] },
			266: { name: ['266 宜蘭縣三星鄉', 'San Xing Village, Yilan County 266', '266 宜兰县三星乡'] },
			267: { name: ['267 宜蘭縣大同鄉', 'Da Tong Village, Yilan County 267', '267 宜兰县大同乡'] },
			268: { name: ['268 宜蘭縣五結鄉', 'Wu Jie Village, Yilan County 268', '268 宜兰县五结乡'] },
			269: { name: ['269 宜蘭縣冬山鄉', 'Dong Shan Village, Yilan County 269', '269 宜兰县冬山乡'] },
			270: { name: ['270 宜蘭縣蘇澳鎮', 'Su Ao Township, Yilan County 270', '270 宜兰县苏澳镇'] },
			272: { name: ['272 宜蘭縣南澳鄉', 'Nan Ao Village, Yilan County 272', '272 宜兰县南澳乡'] },
			//290: { name: ['釣魚台', 'Diaoyutai', '钓鱼台'] }
		}
	},
	'29': {
		name: ['澎湖縣', 'Peng Hu County', '澎湖县'],
		children: {
			880: { name: ['880 澎湖縣馬公市', 'Ma Gong City, Peng Hu County 880', '880 澎湖县马公市'] },
			881: { name: ['881 澎湖縣西嶼鄉', 'Xi Yu Village, Peng Hu County 881', '881 澎湖县西屿乡'] },
			882: { name: ['882 澎湖縣望安鄉', 'Wang An Village, Peng Hu County 882', '882 澎湖县望安乡'] },
			883: { name: ['883 澎湖縣七美鄉', 'Qi Mei Village, Peng Hu County 883', '883 澎湖县七美乡'] },
			884: { name: ['884 澎湖縣白沙鄉', 'Bai Sha Village, Peng Hu County 884', '884 澎湖县白沙乡'] },
			885: { name: ['885 澎湖縣湖西鄉', 'Hu Xi Village, Peng Hu County 885', '885 澎湖县湖西乡'] }
		}
	},
	'30': {
		name: ['金門縣', 'Jin Men County', '金门县'],
		children: {
			890: { name: ['890 金門縣金沙鎮', 'Jin Sha Township, Jin Men County 890', '890 金门县 金沙镇'] },
			891: { name: ['891 金門縣金湖鎮', 'Jin Hu Township, Jin Men County 891', '891 金门县 金湖镇'] },
			892: { name: ['892 金門縣金寧鄉', 'Jin Ning Village, Jin Men County 892', '892 金门县 金宁乡'] },
			893: { name: ['893 金門縣金城鎮', 'Jin Cheng Township, Jin Men County 893', '893 金门县 金城镇'] },
			894: { name: ['894 金門縣烈嶼鄉', 'Lie Yu Village, Jin Men County 894', '894 金门县 烈屿乡'] },
			896: { name: ['896 金門縣烏坵鄉', 'Wu Qiu Village, Jin Men County 896', '896 金门县 乌丘乡'] }
		}
	},
	'31': {
		name: ['連江縣', 'Lian Jiang County', '连江县'],
		children: {
			209: { name: ['209 連江縣南竿鄉', 'Nan Gan Village, Lian Jiang County 209', '209 连江县南竿乡'] },
			210: { name: ['210 連江縣北竿鄉', 'Bei Gan Village, Lian Jiang County 210', '210 连江县北竿乡'] },
			211: { name: ['211 連江縣莒光鄉', 'Ju Guang Village, Lian Jiang County 211', '211 连江县莒光乡'] },
			212: { name: ['212 連江縣東引鄉', 'Dong Yin Village, Lian Jiang County 212', '212 连江县东引乡'] }
		}
	}
});
